"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitView = exports.SPLIT_VIEW_COLUMN_GAP = void 0;
var tslib_1 = require("tslib");
var pdfTheme_1 = require("../pdfTheme");
exports.SPLIT_VIEW_COLUMN_GAP = pdfTheme_1.pdfTheme.spacing.default;
var SplitView = /** @class */ (function () {
    function SplitView(leftColumn, rightColumn) {
        this.leftColumn = leftColumn;
        this.rightColumn = rightColumn;
        this.nodes = [];
        this.nodes = tslib_1.__spreadArray(tslib_1.__spreadArray([], leftColumn, true), rightColumn, true);
    }
    SplitView.prototype.exportContent = function () {
        return {
            columnGap: exports.SPLIT_VIEW_COLUMN_GAP,
            columns: [
                {
                    stack: this.leftColumn.map(function (node) { return node.exportContent(); })
                },
                {
                    stack: this.rightColumn.map(function (node) { return node.exportContent(); })
                }
            ]
        };
    };
    return SplitView;
}());
exports.SplitView = SplitView;
//# sourceMappingURL=SplitView.js.map